import React, { Component, PropTypes } from 'react';
import MarkdownScript from 'helpers/markdownScript';
import AddEditClassModal from '../dashboard/addEditClassModal';
import history from 'router/history';
import ConfirmAddClassModal from "views/dashboard/confirmAddClassModal";
import {parseCookie} from 'services/cookie';
import * as programs from "services/programs";

export default class ProgramPanel extends Component {

  static propTypes = {
    userId: PropTypes.string.isRequired,
    sessions: PropTypes.object.isRequired,
    program: PropTypes.object.isRequired,
    programs: PropTypes.array.isRequired,
    createSession: PropTypes.func.isRequired,
    updateSession: PropTypes.func.isRequired,
    resetAddEditClassForm: PropTypes.func.isRequired,
    updateProfile: PropTypes.func.isRequired
  };

  static contextTypes = {
    staff: PropTypes.bool,
    regionData: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    profile: PropTypes.object.isRequired,
    i18n: PropTypes.func.isRequired
  };

  constructor (props) {
    super(props);
    this.state = {
      showPrepareModal: false,
      showAddEditClassModal: false,
      showConfirmAddClassModal: false,
      addClassData: null
    };
  }

  closeAddEditClassModal() {
    return new Promise((resolve) => {
      this.setState({showAddEditClassModal: false}, resolve);
    });
  }

  handleCancelAddClass() {
    this.setState({ showConfirmAddClassModal: false, showAddEditClassModal: false, addClassData: null });
  }

  hasActiveSessionForProgram() {
    const { sessions: {sessions}, program } = this.props;
    for(let k of Object.keys(sessions)) {
      const session = sessions[k];
      if (session.programId !== program.id) continue;
      if (session.archivedAt) continue;
      if (!session.funding) continue;
      if (session.validUntil < Date.now()) continue;
      return true
    }
    return false
  }

  handleAddClass(data) {
    if (this.hasActiveSessionForProgram()) {
      this.setState({ showConfirmAddClassModal: true, addClassData: data });
      return
    }
    this.createSession(data);
  }

  handleConfirmAddClass() {
    const { addClassData } = this.state;
    this.setState({ showConfirmAddClassModal: false, addClassData: null }, () => {
      this.createSession(addClassData);
    });
  }

  createSession (data) {
    const { userId, program, createSession, updateProfile, sessions } = this.props;
    const { staff } = this.context;
    const contractId = tryGetCookieValue("contractId");
    const { id: programId } = program;
    const { language, grade, divisionName, numberOfStudents } = data;
    const { referrerUserId } = (parseCookie(tryGetCookieValue('ppa_referral')) || this.context.profile);
    const hasFeaturedPrograms = programs.hasFeaturedPrograms();
    createSession(userId, programId, {
      language,
      grade,
      divisionName,
      numberOfStudents: parseInt(numberOfStudents, 10),
      pendingApproval: !(staff || (hasFeaturedPrograms && contractId)),
      firstClass: sessions.sessionList && sessions.sessionList.length === 0,
      contractId: hasFeaturedPrograms && contractId,
      referrerUserId
    }).then(() => {
      if (this.context.profile.gettingStartedOptIn) return;
      return updateProfile(userId, {...this.context.profile, gettingStartedOptIn: true, consent: 'implicit'});
    }).then(() => {
      return this.closeAddEditClassModal()
    }).then(() => {
      //Using a timeout is the only possible option
      setTimeout(() => this.redirectToDashboard(), 500);
    })
  }

  redirectToDashboard() {
    const { query } = this.context.location;
    history.pushState(null, `/`, query)
  }

  openAddEditClassModal () {
    const { resetAddEditClassForm } = this.props;
    const fp = programs.getFeaturedProgramHelper(this.props.program.id)
    resetAddEditClassForm({
      program: fp.programId,
      language: fp.featuredLanguage
    });
    this.setState({ showAddEditClassModal: true });
  }

  render () {
    const {
      showAddEditClassModal,
      showConfirmAddClassModal
    } = this.state;
    const {
      program,
      programs
    } = this.props;
    const {
      regionData,
      i18n: _
    } = this.context;
    const {
      id: programId,
      longDescription,
      levelsDescription,
      thumbnailImage
    } = program;
    const availablePrograms = programs.filter(prog => prog.id === programId);
    const mdDescription = new MarkdownScript(_(longDescription));
    const mdLevels = new MarkdownScript(_(levelsDescription));
    return (
      <div key={programId} className="well programWell row">
        <div className="col-md-3 col-sm-2 program-thumb">
          <img src={_(thumbnailImage)} />
        </div>
        <div className="col-md-8 col-sm-10 programPanelProgramTitleContainer">
          <h4 className="programPanelProgramTitle">{_(program.title)}</h4>
        </div>
        <div className="col-md-4 col-sm-4 programDescriptionDiv">
          <div dangerouslySetInnerHTML={{__html: mdDescription.getAllAsHtml(regionData)}} />
            <div className="col-md-2 programTitleDiv">
              <div>
                <button
                  className="btn btn-default btn-sm glyphicon glyphicon-plus"
                  onClick={::this.openAddEditClassModal}>
                    Add class
                </button>
              </div>

              <AddEditClassModal
                 programs={availablePrograms}
                 showModal={showAddEditClassModal}
                 onSubmit={::this.handleAddClass}
                 closeModal={::this.closeAddEditClassModal}/>

              <ConfirmAddClassModal
                showModal={showConfirmAddClassModal}
                onCancel={::this.handleCancelAddClass}
                onConfirm={::this.handleConfirmAddClass} />

            </div>
        </div>
        <div className="col-md-4 col-sm-6 programLevelsInclude">
          <div dangerouslySetInnerHTML={{__html: mdLevels.getAllAsHtml(regionData)}} />
        </div>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/views/programs/programPanel.jsx